{
  "login": {
    "welcomeBackTitle": "Welcome back.",
    "tagline": "Every auction. One tap away.",
    "emailLabel": "Email",
    "requiredHint": "Required",
    "passwordLabel": "Password",
    "showPassword": "Show",
    "hidePassword": "Hide",
    "signInButton": "Sign in",
    "signingInButton": "Signing in…",
    "orContinueWith": "or continue with",
    "newHerePrompt": "New here?",
    "createAccountLink": "Create an account",
    "missingDetailsTitle": "Missing details",
    "missingDetailsMessage": "Enter your email and password to continue.",
    "pendingApprovalTitle": "Account pending approval",
    "pendingApprovalMessage": "Your dealer account is awaiting approval. We'll email you the moment it's approved.",
    "invalidCredentialsTitle": "Couldn't sign you in",
    "invalidCredentialsMessage": "Double-check your email and password. Caps lock can be sneaky.",
    "forgotPasswordAction": "Forgot password?",
    "passwordResetTitle": "Password reset",
    "passwordResetMessage": "Self-serve password reset is coming soon. Reach out to your dealer admin for now.",
    "noConnectionMessage": "Your request didn't reach us. Check your signal and try again.",
    "socialSignInComingSoonMessage": "Social sign-in is on the way. Use email for now.",
    "emailPlaceholder": "you{'@'}example.com",
    "signingInTitle": "Signing you in…",
    "signingInLede": "Taking you to the AutoAuction.com sign-in page.",
    "failedTitle": "Sign-in didn't complete",
    "failedCancelled": "Sign-in was cancelled before it finished. Try again when you're ready.",
    "failedExpired": "That sign-in step expired. Try again to start a fresh one.",
    "failedService": "We couldn't reach the sign-in service. Wait a moment and try again.",
    "failedGeneric": "Something went wrong while signing you in. Try again.",
    "retryButton": "Try again",
    "accountNotLinked": "You signed in, but no approved dealer account matches this email yet."
  },
  "linking": {
    "notLinkedTitle": "Let's set you up",
    "notLinkedSignedInAs": "You signed in with {provider} as",
    "notLinkedLede": "This login doesn't have an AutoAuction.com account yet.",
    "connectExistingButton": "I already have an account",
    "matchTitle": "You already have an account",
    "matchLede": "Connect this {provider} login and you can use either one to sign in next time.",
    "connectContinueButton": "Connect and continue",
    "sheetTitle": "Sign in to your existing account",
    "sheetLede": "We'll take you to the sign-in page. Sign in once with the login you already use, and we'll connect this {provider} login to that account.",
    "sheetStep1": "Sign in with your existing login",
    "sheetStep2": "We verify it's your account",
    "sheetStep3": "Next time, sign in with either login",
    "sheetContinueButton": "Continue to sign-in",
    "sheetCancelButton": "Cancel",
    "createAccountButton": "Set up my account",
    "notNowLink": "Not now — sign out",
    "restorableTitle": "Welcome back",
    "restorableLede": "This login belonged to an account that was closed. You can restore it — everything is still here — or start fresh.",
    "restoreButton": "Restore my account",
    "startFreshButton": "Start fresh with a new account",
    "welcomeTitle": "Welcome to AutoAuction.com, {name}",
    "welcomeLede": "Your account is ready. Access to auctions is granted by your dealership or auction house — ask them to invite you, and the invitation will arrive on this account.",
    "welcomeButton": "Go to my account",
    "pageTitle": "Sign-in & security",
    "connectionsTitle": "Your sign-in methods",
    "connectedOn": "Added {date}",
    "unlinkButton": "Unlink",
    "unlinkLastHint": "This is your only sign-in method — add another before removing it.",
    "unlinkConfirm": "Remove this sign-in method? You can add it back later.",
    "addLoginButton": "Add a login",
    "addLoginTitle": "Choose a login to add",
    "addLoginHint": "You'll sign in with it once so we can prove it's yours.",
    "providerLocal": "Email & password",
    "linkedTitle": "Login connected",
    "linkedLede": "You can sign in with it from now on.",
    "linkRefusedTitle": "That login wasn't connected",
    "linkRefusedLede": "Couldn't connect that login: {reason}",
    "linkOutcomeBackButton": "Back to Sign-in & security",
    "closeTitle": "Close my account",
    "closeRow": "Close my account",
    "closeLede": "Closing your account signs you out everywhere and removes your contact details from our records. Your past bids and sales stay in the auction records. You can restore your account any time by signing in with any of the logins you had.",
    "closeConfirmButton": "Close my account",
    "closeFinalConfirm": "Close your account now?",
    "closeCancelButton": "Keep my account",
    "errorGeneric": "Something didn't work. Try again.",
    "connectionInUse": "That login is already connected to a different account.",
    "signedInAs": "Signed in as",
    "backToAppButton": "Back to the app"
  },
  "profile": {
    "title": "Profile",
    "photoHint": "Photo upload lands with the verification flow.",
    "identityTitle": "Identity",
    "nameLabel": "Name",
    "namePlaceholder": "Your name",
    "primaryEmailLabel": "Primary email",
    "primaryEmailHint": "Choose from the addresses your logins have verified.",
    "primaryEmailOnlyOne": "Add a login in Sign-in & security to choose another address.",
    "phoneLabel": "Phone",
    "discardButton": "Discard",
    "savingButton": "Saving…",
    "saveChangesButton": "Save changes",
    "requiredError": "Required",
    "saved": "Profile saved.",
    "saveFailed": "Couldn't save — try again.",
    "backButton": "Back"
  },
  "sessions": {
    "title": "Active sessions",
    "lede": "Where you are signed in right now.",
    "thisDevice": "This device",
    "browserOnSystem": "{browser} on {system}",
    "unknownBrowser": "Unknown browser",
    "unknownSystem": "an unknown system",
    "signedInWith": "Signed in with {method}",
    "signedInAt": "Signed in {date}",
    "lastActive": "Last active {date}",
    "ipAddress": "IP address {address}",
    "signOutButton": "Sign out",
    "signOutTitle": "Sign out this device?",
    "signOutMessage": "{device} will be signed out. Signing in there again will need your password or login.",
    "signOutConfirm": "Sign out",
    "everywhereButton": "Sign out everywhere",
    "everywhereTitle": "Sign out everywhere?",
    "everywhereMessage": "Every device you are signed in on will be signed out, this one included. Each one will need your password or login to sign in again.",
    "everywhereConfirm": "Sign out everywhere",
    "cancel": "Cancel",
    "failed": "That didn't work, so nothing was signed out. Try again.",
    "loadFailed": "Your sessions couldn't be loaded.",
    "apps": {
      "mobile-vibe-portal": "AutoAuction.com app",
      "desktop-vibe-portal": "AutoAuction.com Administration"
    }
  },
  "mfa": {
    "title": "Two-step sign-in",
    "lede": "When it is on, signing in with your email and password also asks for a 6-digit code from an authenticator app on your phone.",
    "statusOn": "On",
    "statusOff": "Off",
    "notAvailable": "You are signed in with Google or Microsoft, and their own two-step sign-in covers this account. To set up a code for your email and password, sign in with them.",
    "turnOnButton": "Turn on",
    "turnOffButton": "Turn off",
    "setupTitle": "Set up your authenticator app",
    "scanStep": "Scan this code with an authenticator app, such as Google Authenticator, 1Password or Authy.",
    "scanAlt": "The code to scan with your authenticator app",
    "enterByHand": "Or type this key into the app:",
    "codeLabel": "The 6 digits the app shows",
    "lostWarning": "Keep the app safe. If you lose it, you cannot sign in with your email and password.",
    "confirmButton": "Turn on two-step sign-in",
    "cancelButton": "Cancel",
    "turnOffTitle": "Turn off two-step sign-in?",
    "turnOffMessage": "You will not be asked for a code when you sign in with your email and password.",
    "turnOffConfirm": "Turn off",
    "wrongCode": "That code isn't right. Wait for the app to show a new one and try again.",
    "signInAgain": "Sign in again with your email and password, then come back here.",
    "failed": "That didn't work. Try again.",
    "loadFailed": "Your two-step sign-in settings couldn't be loaded."
  }
}
